import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { TerritoryLocationProvider } from '@/components/location/TerritoryLocationProvider'
import './styles/global.css'
import App from './App'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <TerritoryLocationProvider>
        <App />
      </TerritoryLocationProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
